export default {
  loadActivityTypes ({ commit }, payload) {
    // console.log('VUEX loadActivityTypes payload =', payload)
    commit('LOAD_ALL_ACTIVITY_TYPES', payload)
  },
  setCurrentActivityType ({ dispatch, commit }, payload) {
    // Save the activity type id in the store
    commit('SET_CURRENT_ACTIVITY_TYPE', payload)
    dispatch('settings/updateOneSetting', { feature: 'currentActivityType', value: payload }, { root: true })
  },
  setCurrentActivityTypeObj ({ commit }, payload) {
    // Save the complete activity type obj ONLY in the store (not to IDB)
    commit('SET_CURRENT_ACTIVITY_TYPE_OBJ', payload)
  }
}
